import React from "react";
import { Link as DomLink } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function CartModal(props) {
  const handleClose = () => {
    props.close(false);
  };

  return (
    <Dialog open={props.open} onClose={handleClose}>
      <>
        {props.errors && props.errors.length > 0 ? (
          <>
            <DialogTitle>Cannot Add to Cart</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {props.errors &&
                  props.errors.map((message) => (
                    <Typography key={message} variant="subtitle1">
                      {message}
                    </Typography>
                  ))}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleClose}
                >
                  Close
                </Button>
              </Stack>
            </DialogActions>
          </>
        ) : (
          <>
            <DialogTitle>Add to Cart Successful!</DialogTitle>
            <DialogContent>
              <DialogContentText>
                This item has successfully been added to your cart.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Stack direction="row" spacing={2}>
                <Button variant="contained" onClick={handleClose}>
                  Continue Shopping
                </Button>
                <DomLink
                  to={{
                    pathname: "/cart",
                  }}
                >
                  <Button variant="contained">Go To Cart</Button>
                </DomLink>
              </Stack>
            </DialogActions>
          </>
        )}
      </>
    </Dialog>
  );
}
